export default "__VITE_ASSET__D_hJ$_5B__"